module.exports = __webpack_public_path__ + "static/media/empty_project.88c30b58.svg";